<div nz-col nzSpan="24">
	<input style="display:none" type="text">
	<input style="display:none" type="password">
</div>


<div class="customize-select" *ngIf="controlDef?.type === 'select'">
	<nz-form-item>
		<nz-form-control [nzValidateStatus]="getSelectValidationStatus()">
			<nz-select id="{{controlDef.id?controlDef.id:'custom-select'}}" class="w-100p" [(ngModel)]="selectedItem"
				(ngModelChange)="writeValue($event)" (nzOpenChange)="setControlTouched()" nzAllowClear nzShowSearch
				[disabled]="disabled"
				[nzPlaceHolder]="getSelectValidationStatus() === 'error'?controlDef?.placeholder:''" nzAllowClear
				[nzDropdownRender]="renderTemplate" [nzLoading]="isLoadingItems" [nzSuffixIcon]="customDropDown">
				<nz-option *ngFor="let item of selectItems" [nzValue]="item?.value" [nzLabel]="item?.label">
				</nz-option>
				<nz-option nzCustomContent *ngFor="let item of selectOptionsItems" [nzValue]="item?.value"
					[nzLabel]="item?.value">
					<ng-container [ngTemplateOutlet]="selectOptionsTemplate"
						[ngTemplateOutletContext]="{link:item}"></ng-container>
				</nz-option>
			</nz-select>
			<ng-template #renderTemplate>
				<nz-spin *ngIf="isLoadingItems"></nz-spin>
			</ng-template>
			<div class="custom-select-label
  				{{getSelectValidationStatus() === 'error'?'error-label ':''}}{{getSelectClass()}}">
				<label (click)="openSelect()">{{controlDef?.placeholder}}</label>
			</div>
		</nz-form-control>
	</nz-form-item>
	<ng-template #customDropDown>
		<app-icon icon="drop-down-select"></app-icon>
	</ng-template>
</div>

<div *ngIf="controlDef?.type !== 'select'">
	<nz-form-item>
		<nz-form-control nzErrorTip="">


			<ng-container *ngIf="controlDef.type !== 'date', else dateInput">
				<!-- <nz-input-group class=" true ? moniepoint-input " [nzPrefix]="prefixTemplate" [nzSuffix]="suffixTemplate"></nz-input-group> -->
				<nz-input-group [ngClass]="{'moniepoint-input ':!disabled,'disable-form':disabled} "
					[nzPrefix]="prefixTemplate" [nzSuffix]="suffixTemplate">
					<input (keyup)="writeValue($event)" (blur)=" handleOnBlur()" (focus)="handleFocus()"
						(touchend)="writeValue($event)" (paste)="writeValue($event)" [formControl]="controlDef.formGroupControl"
						[placeholder]="showPlaceholder? controlDef.placeholder : ''"
						[autocomplete]="'new-' + controlDef.type" maxlength="{{controlDef?.maxLength}}" nz-input
						type="{{passwordVisible? 'text' : controlDef.type}}" [disabled]="disabled"
						[readonly]="disabled" />
				</nz-input-group>
				<small *ngIf="hasMaximumValueError() && controlDef.showError" class="text-error">Value is above maximum
					permitted.
				</small>
				<small *ngIf="controlDef.formGroupControl.hasError('fieldMismatch')" class="text-error">
					{{controlDef.name}}s do not match.
				</small>
				<small *ngIf="errorMessage" class="text-error">
					{{errorMessage}}
				</small>
			</ng-container>

			<!-- <ng-container *ngIf="controlDef.type !== 'date', else dateInput">
				<nz-input-group class="moniepoint-input" [nzPrefix]="prefixTemplate" [nzSuffix]="suffixTemplate">
					<input (keyup)="writeValue($event)" (blur)="handleOnBlur()" (focus)="handleFocus()"
						(touchend)="writeValue($event)" [formControl]="controlDef.formGroupControl"
						[placeholder]="showPlaceholder? controlDef.placeholder : ''" autocomplete="off"
						maxlength="{{controlDef?.maxLength}}" nz-input
						type="{{passwordVisible? 'text' : controlDef.type}}" />
				</nz-input-group>
				<small *ngIf="hasMaximumValueError() && controlDef.showError" class="text-error">Value is above maximum
					permitted.
				</small>
				<small *ngIf="controlDef.formGroupControl.hasError('fieldMismatch')" class="text-error">
					{{controlDef.name}}s do not match.
				</small>
			</ng-container> -->


			<ng-template #dateInput>
				<div>
					<nz-date-picker (focusin)="handleFocus()" (ngModelChange)="handleOnBlur()"
						[formControl]="controlDef.formGroupControl" [nzDisabledDate]="disabledDate"
						[nzPlaceHolder]="' '" [nzSuffixIcon]="calendar" style="width:100%">
					</nz-date-picker>
				</div>
			</ng-template>

		</nz-form-control>
	</nz-form-item>


	<!-- <ng-template #suffixTemplate>
	<ng-container *ngIf="iconPosition && iconPosition === 'right'">
		<i nz-icon nzTheme="fill" [nzType]="passwordVisible ? 'eye-invisible' : 'eye'"
			(click)="passwordVisible = !passwordVisible"></i>
	</ng-container>
</ng-template> -->

	<ng-template #calendar>
		<svg fill="none" height="20" viewBox="0 0 24 20" width="24" xmlns="http://www.w3.org/2000/svg">
			<path clip-rule="evenodd"
				d="M18.8766 3.36369H20.974C22.1308 3.36369 23.0714 4.11367 23.0714 5.03402V17.5615C23.0714 18.4827 22.1308 19.2318 20.974 19.2318H2.0974C0.940686 19.2318 0 18.4827 0 17.5615V5.03402C0 4.11367 0.940686 3.36369 2.0974 3.36369H4.19481V5.86918H6.29221V1.69336H8.38962V3.36369H14.6818V5.86918H16.7792V1.69336H18.8766V3.36369ZM3.14629 16.7263H7.3411V13.3857H3.14629V16.7263ZM7.3411 11.7153H3.14629V8.37467H7.3411V11.7153ZM9.43847 16.7263H13.6333V13.3857H9.43847V16.7263ZM13.6333 11.7153H9.43847V8.37467H13.6333V11.7153ZM15.7306 11.7153H19.9254V8.37467H15.7306V11.7153Z"
				fill="#273D50" fill-opacity="0.249434" fill-rule="evenodd" />
		</svg>
	</ng-template>

	<ng-template #suffixTemplate>
		<ng-container *ngIf="(iconPosition && iconPosition === 'right') || suffixType">
			<ng-container [ngSwitch]="suffixType">
				<ng-container *ngSwitchCase="'loader'">
					<i *ngIf="isLoadingItems" nz-icon nzType="loading" nzTheme="outline"></i>
				</ng-container>
				<ng-container *ngSwitchCase="'eye'">
					<i (click)="passwordVisible = !passwordVisible" [nzType]="passwordVisible ? 'eye-invisible' : 'eye'"
						nz-icon nzTheme="fill"></i>
				</ng-container>
				<ng-container *ngSwitchCase="'correct'">
					<i
						*ngIf="showCorrectIcon"
						nz-icon
						[nzType]="'check-circle'"
						[nzTheme]="'fill'"
						style="font-size: 19px; color: #52c41a"
					></i>
				</ng-container>

				<ng-container *ngSwitchCase="'success'">
					<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
						<circle cx="8.16699" cy="7.66699" r="5" fill="white" />
						<path
							d="M8.49967 14.6664C4.81945 14.6623 1.83705 11.6799 1.83301 7.99969V7.86635C1.9063 4.20271 4.92273 1.28499 8.58679 1.33361C12.2508 1.38222 15.1888 4.37894 15.1649 8.04324C15.1409 11.7075 12.1641 14.6656 8.49967 14.6664ZM5.91013 8.19499C5.65016 7.93602 5.2296 7.93643 4.97013 8.1959C4.7103 8.45572 4.7103 8.87698 4.97013 9.13681L6.44676 10.6134C6.84418 11.0109 7.48851 11.0109 7.88592 10.6134L12.0297 6.46969C12.2895 6.20985 12.2903 5.78879 12.0313 5.52803C11.7711 5.26596 11.3475 5.26521 11.0863 5.52636L7.31991 9.29279C7.23505 9.37765 7.0975 9.37778 7.01248 9.29309L5.91013 8.19499Z"
							fill="#1EB12D"
						/>
					</svg>
				</ng-container>

				<ng-container *ngSwitchDefault>

					<app-grey-icon (click)="passwordVisible = !passwordVisible" greyIcon="grey-eye"
						style="margin-top: 6px;">
					</app-grey-icon>
				</ng-container>
				<ng-container *ngSwitchCase="'grey-eye-small'">

					<app-grey-icon (click)="passwordVisible = !passwordVisible" greyIcon="grey-eye-small"
						style="margin-top: 6px;">
					</app-grey-icon>
				</ng-container>
			</ng-container>
		</ng-container>
	</ng-template>

	<ng-template #prefixTemplate>
		<ng-container *ngIf="(iconPosition && iconPosition === 'left') || prefixType">
			<ng-container [ngSwitch]="prefixType">
				<ng-container *ngSwitchCase="'loader'">
					<nz-spin *ngIf="isLoadingItems"></nz-spin>
				</ng-container>
				<ng-container *ngSwitchCase="'grey-user'">
					<app-grey-icon greyIcon="grey-user">
					</app-grey-icon>
				</ng-container>
				<ng-container *ngSwitchCase="'grey-lock'">
					<app-grey-icon greyIcon="grey-lock">
					</app-grey-icon>
				</ng-container>
				<ng-container *ngSwitchCase="'grey-bank'">
					<app-grey-icon greyIcon="grey-bank">
					</app-grey-icon>
				</ng-container>
				<ng-container *ngSwitchCase="'naira-symbol'">
					<svg width="26" height="22" viewBox="0 0 26 22" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path fill-rule="evenodd" clip-rule="evenodd"
							d="M17.582 0.236328H22.1583V5.29102H26V9.2365H22.1583V12.6707H26V16.6162H22.1583V21.7636H18.1872L14.5931 16.6162H8.56736V21.7636H3.96981V16.6162H0V12.6707H3.96981V9.2365H0V5.29102H3.96981V0.236328H8.00461L11.509 5.29102H17.582V0.236328ZM17.582 9.2365H14.2444L16.6253 12.6707H17.582V9.2365ZM11.8382 12.6707L9.44027 9.2365H8.56736V12.6707H11.8382Z"
							fill="#19191A" />
					</svg>
				</ng-container>
				<ng-container *ngSwitchCase="'grey-phone'">
					<app-grey-icon greyIcon="grey-phone">
					</app-grey-icon>
				</ng-container>
				<ng-container *ngSwitchCase="'grey-email'">
					<app-grey-icon greyIcon="grey-email">
					</app-grey-icon>
				</ng-container>
				<ng-container *ngSwitchCase="'grey-avatar'">
					<app-grey-icon greyIcon="grey-avatar">
					</app-grey-icon>
				</ng-container>
				<ng-container *ngSwitchCase="'grey-search'">
					<app-grey-icon greyIcon="grey-search">
					</app-grey-icon>
				</ng-container>
			</ng-container>
		</ng-container>
	</ng-template>
</div>